export default __webpack_public_path__ + "static/media/notion-icon.790ef663.svg";